import axios from "axios";
import { toast } from "react-hot-toast";

export function createSipRuntime(ctx) {
  let stopped = false;

  const sip = {
    form: {
      getValue: (field) => ctx.record?.[field],
      setValue: (field, value) => ctx.setRecord((prev) => ({ ...prev, [field]: value })),
      getRecord: () => ctx.record,
      getTable: () => ctx.tableName,
      getRecordId: () => ctx.recordId,
      save: (redirect = false) => ctx.handleSave(redirect),
      refresh: () => ctx.loadForm(),
      isNew: () => ctx.recordId === "new",
    },

    toast: {
      success: toast.success,
      error: toast.error,
      info: toast,
      warning: toast,
    },

    dialog: {
      confirm: (message) => window.confirm(message),
      alert: (message) => window.alert(message),
    },

    navigation: {
      backToList: () => ctx.navigate(`/dashboard/${ctx.tableName}/list_view`),
      openRecord: (table, id) => ctx.navigate(`/dashboard/${table}/form_view/${id}`),
      reload: () => window.location.reload(),
    },

    action: {
      stop: () => {
        stopped = true;
      },
      isStopped: () => stopped,
      executeServer: async (action, clientPayload = {}) => {
        const res = await axios.post(
          `${ctx.apiBaseUrl}/ui-actions/${action.id}/execute`,
          {
            table_name: ctx.tableName,
            record_id: ctx.recordId,
            selected_ids: [],
            client_payload: clientPayload,
          },
          { headers: { Authorization: `Bearer ${ctx.token}` } }
        );
        return res.data;
      },
    },
  };

  return sip;
}

export async function executeUiAction(action, sip) {
  try {
    if (action.sip_requires_confirmation && action.sip_confirm_text) {
      const ok = sip.dialog.confirm(action.sip_confirm_text);
      if (!ok) return;
    }

    if (action.sip_client_script?.trim()) {
      const fn = new Function("sip", action.sip_client_script);
      await fn(sip);
    }

    if (sip.action.isStopped()) return;

    const serverResult = await sip.action.executeServer(action);

    if (action.sip_after_script?.trim()) {
      const fn = new Function("sip", "result", action.sip_after_script);
      await fn(sip, serverResult);
    }

    if (serverResult?.refresh || action.sip_refresh_after) {
      await sip.form.refresh();
    }
  } catch (error) {
    console.error("UI Action failed:", error);
    sip.toast.error("UI Action failed.");
  }
}